import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import Menu, { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import { withRouter } from "react-router-dom";
import moment from 'moment'
import jsPDF from 'jsPDF'
import html2canvas from 'html2canvas'
import htmlDocx from 'html-docx-js/dist/html-docx';

import * as meetingdetails from '../../../actions/meetingdetails';
import * as filedownload from '../../../actions/fileupload';

import Publish from './publish'
import Notification from './notification'
import DeleteMeeting from './deletemeeting'
import ArchiveMeeting from './archivemeeting'


class CardMenu extends React.Component {

    render() {
        const ITEM_HEIGHT = 40;
        const options = [
            { id: 1, name: 'View / Update' },
            { id: 2, name: 'Delete' },
            { id: 3, name: 'Notification' },
            { id: 4, name: 'Publish' },
            { id: 5, name: 'Archive' },
            // { id: 6, name: 'Meeting Minutes' }, //commented from the version 6.0.0s
        ];
        const { menuState, anchorEl, handleRequestClose } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    <MenuItem key={option.id} onClick={handleRequestClose.bind(this, option.id)}>
                        {option.name}
                    </MenuItem>,
                )}
            </Menu>
        );
    }

}

const columnData = [
    { id: 'smeetingId', numeric: false, disablePadding: false, label: 'S.No.' },
    { id: 'meetingNumber', numeric: false, disablePadding: true, label: 'Meeting Number' },
    { id: 'meetingName', numeric: false, disablePadding: true, label: 'Meeting Name' },
    { id: 'meeting_status', numeric: false, disablePadding: true, label: 'Status' },
    { id: 'm_Date', numeric: false, disablePadding: true, label: 'Meeting Date' },
    { id: 'action', numeric: false, disablePadding: true, label: 'Actions' },
];

class DataTableHead extends React.Component {
    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'checkbox'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

class ExportHTML extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        const { data } = this.props
        if (data)
            this.props.generateDocPDF(data.meetingNumber)
    }
    render() {
        const { data } = this.props;
        return (
            // https://wordtohtml.net/
            <div className="hidden1" style={{ height: 0, opacity: 0 }}>
                <div id="divToPrint" >
                    {data && <div id="divSet" className="flex-auto" style={{ width: '90%', fontSize: '18pt', }}>
                        <h1 style={{ textAlign: 'center' }}>Meeting Minutes - {data.meetingName}</h1>
                        <table className="blueTable" style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '40%' }}>Date:</td>
                                    <td style={{ width: '50%' }}>{moment(data.m_Date).format('DD/MM/YYYY')}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '40%' }}>Time:</td>
                                    <td style={{ width: '50%' }}>{moment(moment().format('DD/MM/YYYY') + ' ' + data.m_Time).format('hh:mm')}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '40%' }}>Location:</td>
                                    <td style={{ width: '50%' }}>{data.location}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '40%' }}>Meeting Number:</td>
                                    <td style={{ width: '50%' }}>{data.meetingNumber}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <h2>Attendee Details</h2>
                            <table className="blueTable" style={{ width: '100%', }} border="1">
                                <thead>
                                    <tr style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
                                        <th style={{ width: '3%' }}>#</th>
                                        <th style={{ width: '28%' }}>Attendee User Id</th>
                                        <th style={{ width: '28%' }}>User Name</th>
                                        {/* <th style={{ width: '28%' }}>Department</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.meeting_user.map((_data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{_data.userId}</td>
                                                <td>{_data.userName}</td>
                                                {/* <td></td> */}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <h2>Agenda Details</h2>
                            <table className="blueTable" style={{ width: '100%' }} border="1">
                                <thead>
                                    <tr style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
                                        <th style={{ width: '3%' }}>#</th>
                                        <th style={{ width: '28%' }}>Item</th>
                                        <th style={{ width: '28%' }}>Headed By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.agendaList.map((_data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{_data.agenda}</td>
                                                <td>{_data.headed_by}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {/* <table className="blueTable" style={{ width: '100%' }}>
                            <tbody>
                                <tr><td style={{ textAlign: 'right', paddingRight: '30px', }}><b>APPROVED BY</b><br /></td></tr>
                                <tr><td style={{ textAlign: 'right', paddingRight: '30px', }}><b>Approver's name</b><br /></td></tr>
                            </tbody>
                        </table> */}
                        <br /><b>Recorded By</b><br />
                        {data.headedby}
                    </div>
                    }
                </div>
            </div>
        );
    }
}

class DataTable extends React.Component {
    handleRequestSort = (event, property) => {
        // console.log('sort property',property)
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        // console.log('this.state.data',this.state.data)

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };


    onOptionMenuSelect = (data, event) => {
        this.state.id = data;
        this.setState({ id: data, menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose(data, click_id, e) {
        this.setState({ menuState: false, });
        if (click_id == 1) {
            // console.log('this.state.open out1', this.state.openDialog);
            // this.props.actions.setMeetingDetails(data);
            this.props.history.push('/meeting/add-meeting/' + data);
        }
        else if (click_id == 2) {
            // this.setState({open: true});
            this.setState({ openDeleteDialog: true });
        }
        else if (click_id == 3) {
            // this.setState({open: true});
            this.setState({ openNotificationDialog: true });
        }
        else if (click_id == 4) {
            // console.log(this.props)
            this.setState({ openDialog: true });
        }
        else if (click_id == 5) {
            // console.log(this.props)
            this.setState({ openArchiveDialog: true });
        }
        else if (click_id == 6) {
            console.log('data ', data);
            // this.props.actions.getMeetingMinutesDetails(data);

            // this.props.actions.fileDownloadMeetingMinutesFile(this.props.data)

            this.setState({ isMeetingMinutesSet: true });
        }
    };

    generateDocPDF(fileName) {
        this.setState({ mmdata: null, downloaded: false });
        // $(input).attr('style', "backgroundColor: 'red';width: '210mm';minHeight: '297mm';marginLeft: 'auto';marginRight: 'auto'")
        const input = '<!DOCTYPE html><html><body>' + document.getElementById('divToPrint').outerHTML + '</body></html>';
        var converted = htmlDocx.asBlob(input);
        // htmlDocx.saveAs(converted, 'test.docx');
        const url = window.URL.createObjectURL(new Blob([converted], { type: 'application/docx' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '_MeetingMinutes.docx');
        document.body.appendChild(link);
        link.click();
        this.props.setInProgress(false);

        // const pdfinput = document.getElementById('divToPrint')
        // // https://github.com/MrRio/jsPDF
        // html2canvas(pdfinput)
        //     .then((canvas, _this = this) => {
        //         document.body.appendChild(canvas);
        //         const imgData = canvas.toDataURL('image/png');
        //         // console.log(pdfinput)
        //         const pdf = new jsPDF('portrait', 'pt', 'a4');
        //         const pdfConf = {
        //             margin: 1,
        //             pagesplit: false,
        //             background: '#fff'
        //         };
        //         _this.state.mmdata = null;
        //         pdf.addHTML(canvas, 20, 20, pdfConf, () => {
        //             document.body.removeChild(canvas);
        //             // pdf.addPage();
        //             pdf.save('download.pdf');
        //         });
        //         this.props.setInProgress(false);
        //     });

    }

    htmlReder() {
        this.setState({ downloaded: false });
    }
    closeDialog = (data) => {
        this.setState({ openDialog: false });
        this.setState({ openNotificationDialog: false });
        this.setState({ openDeleteDialog: false });
        this.setState({ openArchiveDialog: false });
    }
    constructor(props, context) {
        super(props, context);

        this.state = {
            anchorEl: undefined,
            menuState: false,
            openDialog: false,
            openNotificationDialog: false,
            openDeleteDialog: false,
            openArchiveDialog: false,
            order: 'asc',
            orderBy: 'calories',
            data: [],
            page: 0,
            rowsPerPage: 20,
            id: null,
            isMeetingMinutesSet: false,
            mmdata: null,
        };
    }

    render() {
        const { filterText, meetingDetails } = this.props
        const { menuState, anchorEl, data, order, orderBy, selected, rowsPerPage, page, downloadInprogress } = this.state;
        this.state.data = this.props.data
        if (meetingDetails && meetingDetails.apiGetResult && this.state.isMeetingMinutesSet) {
            // console.log('updatefile Popup=>', meetingDetails.meetingdetails)
            this.props.setInProgress(true)
            this.setState({ isMeetingMinutesSet: false });
            this.setState({ mmdata: meetingDetails.meetingdetails })
        }
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material" style={{ overflowX: 'unset' }}>
                        <Table className="">
                            <DataTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={this.state.data ? this.state.data.length : 0}
                            />
                            <TableBody>
                                {/* {console.log('data', this.state.data)} */}
                                {!this.state.data ?
                                    <TableRow>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                    :
                                    this.state.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, index) => {
                                        return (
                                            (!filterText) || (filterText.length > 0 &&
                                                ((n.meetingNumber && n.meetingNumber.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.meetingName && n.meetingName.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.meeting_status && n.meeting_status.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.m_Date && moment(n.m_Date).format('DD/MM/YYYY').toLowerCase().indexOf(filterText) >= 0))) ?
                                                <TableRow hover role="checkbox" tabIndex={- 1} key={index}>
                                                    <TableCell padding="checkbox">{(index + 1) + (page * rowsPerPage)}</TableCell>
                                                    <TableCell padding="none">{n.meetingNumber}</TableCell>
                                                    <TableCell padding="none">{n.meetingName}</TableCell>
                                                    <TableCell padding="none">{n.meeting_status}</TableCell>
                                                    <TableCell padding="none">{moment(n.m_Date).format('DD/MM/YYYY')}</TableCell>
                                                    <TableCell padding="none">
                                                        <IconButton aria-label="view" onClick={this.onOptionMenuSelect.bind(this, n.smeetingId)}>
                                                            <i className="zmdi zmdi-more-vert"></i>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                : null
                                        )
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={this.state.data ? this.state.data.length : 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[20, 40, 100]}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                        <CardMenu menuState={menuState} anchorEl={anchorEl}
                            handleRequestClose={this.handleRequestClose.bind(this, this.state.id)} />
                        <Publish open={this.state.openDialog} id={this.state.id} closeDialog={this.closeDialog} />
                        <Notification open={this.state.openNotificationDialog} id={this.state.id} closeDialog={this.closeDialog} />
                        <DeleteMeeting open={this.state.openDeleteDialog} id={this.state.id} closeDialog={this.closeDialog} />
                        <ArchiveMeeting open={this.state.openArchiveDialog} id={this.state.id} closeDialog={this.closeDialog} />
                        <ExportHTML data={this.state.mmdata} generateDocPDF={this.generateDocPDF.bind(this)} />
                    </div>
                </div>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(meetingdetails, filedownload, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTable));


// WEBPACK FOOTER //
// ./app/meetingdetails/meetinglist/datatable.js